import { Component, Input, inject } from '@angular/core';
import { TabService } from '@services/tabs/TabService';
import { Pages } from '@constants/pages/Pages';
import { provideTranslocoScope } from '@jsverse/transloco';

@Component({
    selector: 'moi-thirdparty-summary',
    templateUrl: './moi-thirdparty-summary.component.html',
    styleUrls: ['./moi-thirdparty-summary.component.scss'],
    standalone: false,
    providers: [provideTranslocoScope('moi')],
})
export class MoiThirdPartySummaryComponent {
  private tabService = inject(TabService);
  private pages = inject(Pages);

  @Input() summaryModel: any;
  @Input() thirdpartyGUID: any;

  openThirdParty() {
    if (!this.thirdpartyGUID || !this.summaryModel.CanOpenParent) {
      return;
    }

    this.tabService.generateTab(this.pages.ThirdpartyDetail, this.thirdpartyGUID);
  }
}
